import { writable } from 'svelte/store';

export const _completeExamData = writable({});
export const _userObj = writable({});